<div class="header">
  <div class="row">
    <div class="col-md-6">
      <h3>Email-Dashboard(รายงานสรุปการส่งอีเมล)</h3>
      <h6>Total: {{emailTotal}} Transaction</h6>
    </div>
    <div class="col-md-6 row pr-0 z-index-3 justify-content-end">
      <div class="col-md-6 px-0" style="margin-top:10px">
        <div class="dropdown-label-group">
          <p-dropdown
            class="dv-dropdown"
            [options]="companyList"
            [(ngModel)]="selectedCompany"
            [autoDisplayFirst]="true"
            placeholder="บริษัท"
          >
          </p-dropdown>
          <label>บริษัท</label>
        </div>
    </div>
    </div>
  </div>
</div>

<div class="col-12 row m-l-0 m-r-0 p-l-0 p-r-0 row-eq-height">

  <div class="col-md-6 d-flex flex-row p-l-0 p-r-20">
    <div class="col-3 ts-box successChart flex-column"
         [ngClass]="{'selected-successChart': selectedStatus === 'success'}"
         (click)="selectedType('success', 'success')" style="overflow: hidden">
      <h5 class="text-center mt-2 mb-0">Success</h5>
      <div class="canvas">
        <canvas id="successChart">{{myChart1}}</canvas>
      </div>
      <h6 class="text-center mb-2">{{transactions_success}} Transactions</h6>
    </div>
    <div class="col-3 ts-box failedChart flex-column" [ngClass]="{'selected-failedChart': selectedStatus === 'failed'}"
         (click)="selectedType('failed', 'failed')" style="overflow: hidden">
      <h5 class="text-center mt-2 mb-0">Failed</h5>
      <div class="canvas">
        <canvas id="failedChart">{{myChart2}}</canvas>
      </div>
      <h6 class="text-center mb-2">{{transactions_failed}} Transactions</h6>
    </div>
    <div class="col-3 ts-box notSentChart flex-column"
         [ngClass]="{'selected-notSentChart': selectedStatus === 'not_sent'}"
         (click)="selectedType('not_sent', 'not_sent')" style="overflow: hidden">
      <h5 class="text-center mt-2 mb-0">Not Sent</h5>
      <div class="canvas">
        <canvas id="notSentChart">{{myChart3}}</canvas>
      </div>
      <h6 class="text-center mb-2">{{transactions_not_sent}} Transactions</h6>
    </div>
    <div class="col-3 ts-box manuallySentChart flex-column"
         [ngClass]="{'selected-manuallySentChart': selectedStatus === 'manually_sent'}"
         (click)="selectedType('manually_sent', 'manually_sent')" style="overflow: hidden">
      <h5 class="text-center mt-2 mb-0">Manually Sent</h5>
      <div class="canvas">
        <canvas id="manuallySentChart">{{myChart4}}</canvas>
      </div>
      <h6 class="text-center mb-2">{{transactions_manually_sent}} Transactions</h6>
    </div>
  </div>


  <div class="box-filter position-relative z-2 col-md-6" style="padding: 24px 32px 20px 32px;">
    <div class="col-auto searchBox_inner p-l-0 p-r-0">
      <app-filter-header [downloadExcel]="true" [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()" (excel)="downloadExcel()"></app-filter-header>
    </div>
    <div class="row row-eq-height">
      <div class="col-md-6">
        <div class="form-label-group">
          <input class="form-control" type="text" id="searchBuyerTaxId" [(ngModel)]="selectedBuyerTaxId"
                 placeholder="ชื่อผู้ซื้อ/อีเมลล์ผู้ซื้อ/เลขที่ห้อง">
          <label for="searchBuyerTaxId">ชื่อผู้ซื้อ/อีเมลล์ผู้ซื้อ/เลขที่ห้อง</label>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-label-group">
          <input class="form-control" type="text" id="searchDocumentId" [(ngModel)]="selectedDocumentId" placeholder="เลขที่เอกสาร">
          <label for="searchDocumentId">เลขที่เอกสาร</label>
        </div>
      </div>

      <div class="col-md-6" style="margin-top:10px">
        <div class="dropdown-label-group">
          <p-dropdown
            class="dv-dropdown"
            selectId="documentType"
            [options]="rdDocumentType"
            [(ngModel)]="selectedRdDocumentType"
            [autoDisplayFirst]="false"
            placeholder="ประเภทเอกสาร"
          >
          </p-dropdown>
          <label for="documentType">ประเภทเอกสาร</label>
        </div>
      </div>

      <div class="col-md-6" style="margin-top:10px">
        <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside">
          <div class="form-label-group">
            <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange"
                   ngbDropdownToggle placeholder="วันที่ออกเอกสาร" readonly>
            <label for="calendarDropdown">วันที่ออกเอกสาร</label>
            <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
              <span class="far fa-calendar"></span>
            </div>
          </div>
          <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
            <div class="row">
              <div class="col" style="padding-left: 30px">ตั้งแต่</div>
              <div class="col" style="padding-left: 30px">ถึง</div>
            </div>
            <div (click)="stopPropagation($event)">
              <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                          readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                          [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                          [locale]="calendarLocale"></p-calendar>
              <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                          readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                          [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                          [locale]="calendarLocale"></p-calendar>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="box-parent position-relative z-1 m-t-10" style="padding: 24px 32px 20px 32px;">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    [maxSize]="5"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
    *ngIf="loading === false && totalItems !== 0"
  >

    <div *ngIf="selectedStatus !== 'success'">
      <button type="button" class="btn btn-dv btn-wide"
              [disabled]="!canDownloadPdf() || !canDownloadXml || selectedRdDocumentType === 'invoice' || selectedRdDocumentType === 'other'"
              (click)="DownloadSelected(content2, 'xml')">
        ดาวน์โหลด XML
      </button>

      <button type="button" class="btn btn-dv btn-wide"
              [disabled]="!canDownloadPdf()"
              (click)="DownloadSelected(content2, 'pdf')">
        ดาวน์โหลด PDF
      </button>

      <button *ngIf="selectedStatus !== 'manually_sent' && !isViewer() && !isViewerAudit()" type="button" class="btn btn-dv btn-wide"
              [disabled]="!canDownloadPdf()"
              (click)="changeEmailSelectedReportStatus()">
        ส่งเอง
      </button>
    </div>
    <!--<button type="button" class="btn btn-dv btn-clean btn-wide" (click)="selectAll()">เลือกทั้งหมด</button>-->
  </app-custom-pagination>

  <div class="row m-t-20" *ngIf="totalItems === 0 && loading === false ">
    <div class="col-12 text-center">
      <h5>ไม่พบข้อมูล</h5>
    </div>
  </div>

  <div class="m-t-20 text-center scrollable-x-hidden">
    <p-table tableStyleClass="table" *ngIf="totalItems != 0" [loading]="loading" [style]="{'font-size': '11px'}"
             [columns]="tableCol" [value]="datastatus" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">ลำดับ</th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged() ">
            <div
              *ngIf="(selectedStatus != 'not_sent' && selectedStatus != 'manually_sent' )|| col.header != 'อีเมลผู้รับ'">
              {{col.header}}
            </div>
            <!--<p-sortIcon [field]="col.field"></p-sortIcon>-->
          </th>
          <th *ngIf="!isViewer()" scope="col">
            <p-checkbox *ngIf="selectedStatus != 'success'" class="dv-checkbox" binary="true" (onChange)="selectDeselectAll($event)"></p-checkbox>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td class="align-text-top">{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td class="align-text-top">{{data.document_number}}</td>
          <td class="align-text-top">{{data.document_date | date:"dd/MM/yyyy" }}</td>
          <td class="align-text-top">{{data.updated_at | date:"dd/MM/yyyy" }}</td>
          <td class="align-text-top ">{{data.buyer_name}}</td>
          <td class="align-text-top "><p class="with-group">{{data.reference_ref_location}}</p></td>
          <td>
            <i *ngIf="data.additional_data.first_email_notified
                && data.additional_data.first_sms_notified" class="far fa-check-square fa-lg darkblue-color"></i>
            <i *ngIf="!data.additional_data.first_email_notified
                && !data.additional_data.first_sms_notified" class="far fa-square fa-lg darkblue-color"></i>
          </td>
          <td>
            <i *ngIf="data.additional_data.second_email_notified
                && data.additional_data.second_sms_notified" class="far fa-check-square fa-lg darkblue-color"></i>
            <i *ngIf="!data.additional_data.second_email_notified
                && !data.additional_data.second_sms_notified" class="far fa-square fa-lg darkblue-color"></i>
          </td>
          <td class="align-text-top">{{data.document_type}}</td>
          <td class="align-text-top">{{data.status}}</td>
          <td>
            <ul class="mb-0 pl-0" *ngFor="let email of data.receiver_email">
              {{email}}
            </ul>
          </td>
          <td *ngIf="!isViewer()" class="align-text-top">
            <p-checkbox *ngIf="data.status != 'success'" class="dv-checkbox" binary="true"
                        [(ngModel)]="selectedValues[index]" (onChange)="selectIn($event,data)"></p-checkbox>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>

</div>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <!-- <h4 class="modal-title" id="modal-basic-title">Alert</h4> -->
    <button type="button" class="close" aria-label="Close" [disabled]="loading_all_zip" (click)="closeDownloadAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="margin-bottom: 10px">
      <div *ngIf="loading_all_zip" class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin" style="margin-left:5px"></i>
        <br/>
        {{allZipCurrent}} / {{allZipCount}}
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <ngb-progressbar *ngIf="loading_all_zip === true" type="info" [value]="loading_all_zip_progress"
                         height="20px"></ngb-progressbar>
        <span *ngIf="loading_all_zip === false" style="color: #4d5f7a">{{loading_all_zip_message}}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dv btn-danger btn-wide" (click)="closeDownloadAll()">ปิด</button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard-overdue/email-dashboard-overdue/email-dashboard-overdue.component.html